module.exports = {
  breakpointPhoneLarge: 640,
  transitionDurationDefault: 200,
};
